import { AxiosResponse } from 'axios'
import request from '../axios'

export const authenticationUser = async (
    finalFormData: FormData
): Promise<AxiosResponse<any>> => {
    const response = await request.post(
        'http://localhost:8000/api/authentication-user',
        finalFormData
    )
    return response.data
}
